import { type EditorPlugin } from '../../../types/aha-editor';

const CodeSnippetSchemaPlugin: EditorPlugin = {
  name: 'Code snippet schema plugin',
  schema: {
    'code-snippet': {
      isInline: true,
    },
  },
};

export default CodeSnippetSchemaPlugin;
